import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';

import * as Tokens from '@shared/core/tokens';
import { Observable } from 'rxjs';

@Component({
    selector: 'shared-forms-address-autocomplete-input',
    templateUrl: './forms-address-autocomplete-input.shared.component.html',
    styleUrls: ['./forms-address-autocomplete-input.shared.component.scss']
})
export class FormsAddressAutocompleteInputComponent implements OnInit {
    @Input() public compact: boolean = false;
    @Input() public parentForm: FormGroup;
    @Input() public label!: string;
    @Input() public defaultSelected: number;
    @Input() public placeholder!: string;
    @Input() public name: string = 'address';
    @Input() public type: string = 'text';
    @Input() public showHint: boolean = false;
    @Input() public enableClear: boolean = true;

    @Input() public refElem!: HTMLElement;
    @Input() public enabled: boolean = true;

    @Output() public onSelected: EventEmitter<APICommon.IGooglePlaceDetails> = new EventEmitter();

    public valueChangesListener$: Observable<string>;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
    ) { }

    ngOnInit(): void {
        if (this.parentForm && this.name) {
            this.valueChangesListener$ = this.parentForm.get(this.name).valueChanges;
        }
    }

    public handleOnSelectedAddressClick($event: APICommon.IGooglePlaceDetails): void {
        this.onSelected.emit($event);
    }
}
